import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2, ArrowRight } from 'lucide-react';
import api from '@/lib/api';
import { BrandLogo } from '@/components/BrandLogo';
import { ThemeToggle } from '@/components/ThemeToggle';

export default function VerifyEmail() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [status, setStatus] = useState('loading'); // loading | success | error

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    api.post('/auth/verify-email', { token })
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen bg-page flex items-center justify-center px-6" data-testid="verify-page">
      <div className="absolute top-4 right-4"><ThemeToggle /></div>
      <div className="w-full max-w-sm fade-up text-center">
        <BrandLogo className="text-ink mb-6 mx-auto block" />

        {status === 'loading' && (
          <div data-testid="verify-loading">
            <Loader2 strokeWidth={1.5} className="w-10 h-10 text-ink/50 mx-auto animate-spin" />
            <p className="text-ink/60 text-sm mt-4">E-postanız doğrulanıyor...</p>
          </div>
        )}

        {status === 'success' && (
          <div data-testid="verify-success">
            <CheckCircle2 strokeWidth={1.5} className="w-14 h-14 text-pos mx-auto" />
            <h2 className="font-serif text-2xl text-ink mt-4">E-postanız doğrulandı</h2>
            <p className="text-ink/60 text-sm mt-2">
              Teşekkürler! Hesabınız yöneticimiz tarafından onaylandığında tüm özellikler aktif olacaktır.
            </p>
            <button data-testid="verify-continue-btn" onClick={() => navigate('/app')}
              className="w-full mt-6 flex items-center justify-center gap-2 bg-ink text-ground py-3.5 rounded-xl font-semibold transition-transform active:scale-95">
              Uygulamaya Devam Et <ArrowRight strokeWidth={1.5} className="w-4 h-4" />
            </button>
          </div>
        )}

        {status === 'error' && (
          <div data-testid="verify-error">
            <XCircle strokeWidth={1.5} className="w-14 h-14 text-redx mx-auto" />
            <h2 className="font-serif text-2xl text-ink mt-4">Doğrulama başarısız</h2>
            <p className="text-ink/60 text-sm mt-2">
              Bağlantı geçersiz veya süresi dolmuş olabilir. Uygulamaya giriş yapıp doğrulama e-postasını yeniden gönderebilirsiniz.
            </p>
            <button data-testid="verify-back-btn" onClick={() => navigate('/app')}
              className="w-full mt-6 flex items-center justify-center gap-2 bg-ink text-ground py-3.5 rounded-xl font-semibold transition-transform active:scale-95">
              Uygulamaya Git <ArrowRight strokeWidth={1.5} className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
